/* eslint-disable prettier/prettier */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import {
  HeadingDescSmall,
  HeadingWithSpaceLarge
} from '../../Components/Headings';
import {
  AncerWithUnderlineSmall,
  SimpleAncerSmall
} from '../../Components/button';
import HealthCheckLayout from './healthCheckLayout/HealthCheckLayout';
import arrowPink from '../../assets/images/svg/arrow-pink.svg';
import AddMember from '../../Components/addMember/AddMember';
import { HealthResultCards, SimpleCard } from '../../Components/Card';
import './healthCheckHistory.css';

const history = [
  {
    date: 'March 15, 2021',
    link: '/',
    result: [
      { id: 'heart_rate', value: '56' },
      { id: 'oxygen', value: '98' },
      { id: 'respiration', value: '56' },
      { id: 'hrv-sdnn', value: '44.0' },
      { id: 'stress', value: 'low' },
      { id: 'bp', value: '110/70' }
    ]
  },
  {
    date: 'March 15, 2021',
    link: '/',
    result: [
      { id: 'heart_rate', value: '56' },
      { id: 'oxygen', value: '98' },
      { id: 'respiration', value: '56' },
      { id: 'hrv-sdnn', value: '44.0' },
      { id: 'stress', value: 'low' },
      { id: 'bp', value: '110/70' }
    ]
  },
  {
    date: 'March 15, 2021',
    link: '/',
    result: [
      { id: 'heart_rate', value: '56' },
      { id: 'oxygen', value: '98' },
      { id: 'respiration', value: '56' },
      { id: 'hrv-sdnn', value: '44.0' },
      { id: 'stress', value: 'low' },
      { id: 'bp', value: '110/70' }
    ]
  },
  {
    date: 'March 15, 2021',
    link: '/',
    result: [
      { id: 'heart_rate', value: '56' },
      { id: 'oxygen', value: '98' },
      { id: 'respiration', value: '56' },
      { id: 'hrv-sdnn', value: '44.0' },
      { id: 'stress', value: 'low' },
      { id: 'bp', value: '110/70' }
    ]
  }
];

function HealthCheckHistory() {
  return (
    <HealthCheckLayout>
      <section className="healthCheckHistory bgLinghtGray">
        <Container>
          <HeadingWithSpaceLarge text="HEALTHCHECK & HISTORY" />
          <Row>
            <Col md={4}>
              <div className="leftBox whiteBox">
                <AddMember />
              </div>
              <SimpleAncerSmall
                text="scan your vitals"
                to="/healthCheckSubscription"
              />
            </Col>
            <Col md={8}>
              <div className="rightBox">
                {history.map((singleHistory, index) => {
                  const { date, link, result } = singleHistory;
                  return (
                    <SimpleCard key={index}>
                      <div className="firstRow">
                        <div>
                          <HeadingDescSmall text={<b>{date}</b>} />
                        </div>
                        <div>
                          <img src={arrowPink} alt="arrowPink" />
                          <AncerWithUnderlineSmall
                            to={link}
                            text="VIEW DETAILS"
                          />
                        </div>
                      </div>
                      loopstart
                      <HealthResultCards
                        data={result}
                        // // eslint-disable-next-line no-shadow
                        // data={result.map((item, index) => {
                        //   const { id, value } = item;
                        //   console.log(id, index + 1);
                        //   return (
                        //     id === index + 1 || id === '' ? value : ''
                        //   );
                        // })}
                      />

                    </SimpleCard>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default HealthCheckHistory;
